export const qualifiedApplicantsEN = {
    header:'List of qualified applicants',
    stepHeader:{
        one:'select academic year',
        two:'Set up transfer information',
        three:'List of qualified applicants'
    },
    ListAcademicYear:'List of applicants from academic year',
    academicYearTransfer:'Academic year for transfer information',
    createClassroom:'Please create classroom in selected grade level first, go to',
    date:'Date of admission',
    transferred:'Transferred',
    onProcess:'On process',
    confirm:'Confirm',
    transfer:'Transfer',
    cancel:'Cancel',
    save:'Save',
    datePlaceholder:'dd/mm/yy',
    step3Content:'Assign student ID and classrooms for new students to import to student database',
    suggestion:'Suggestion',
    searchByApplicantsNameOnly: "Search by Applicants name", 
    guide:{
        content1:'List of qualified applicants will show only list of applicants with status"Initiation complete" ',
        content2:'Instruction',
        content3:'Assign academic year to transfer information ( for create new academic year go to',
        content4:'Semester Setting',
        content5:')',
        content6:'Fill student ID and classroom follow applicant list (for create new classroom go to',
        content7:'Classroom Setting',
        content8:')',
        content9:'Please recheck then click on  “Transfer”',
        content10:'After transferred system will not allow to change information',
        content11:'Check student database go to',
        content12:'List of student',
    },
    table:{
        fullname:'Fullname',
        curriculum:'Curriculum',
        grade:'Grade',
        studentID:'Student ID',
        classroom:'Classroom',
        status:'Status'
    },
    sheet:{
        academicYear:'Academic year',
        listApplicants:'List of applicants',
        transferred:'Transferred',
        onProcess:'On process',
    },
    input:{
        pleaseFill:'Please fill',
        error:'Please fill information',
        errorExist:'Student ID already exist',
        select:'- Select -',
    },
    dialog:{
        headerUp:'Create student ID only on',
        headerBottom:'selected',
        type:'Type',
        id:'ID',
        numberDigit:'Number of digits',
        numberStart:'Start with',
        example:'Example of student ID',
        add:'Add',
        cancel:'Cancel',
        createId:'Create ID'
    },
    acceptDialog:{
        transfer:'Transfer ?',
        head:'List of applicants : ',
        case:'cases',
        tail:'After confirmation will not allow to change the information'
    },
    createStudentID: 'Create student ID',
    selectRound: 'Select academic round',
    selectAcademic: 'Select academic year',
    error:{
        failToTransfer: 'Failed to transfer',
        case: 'cases',
        fillStartNumber: 'Please fill the number of "start with"',
        maximumDigit: 'Maximum digits of "start with" is',
        fillDigit: 'Please fill number of digits',
        fillStudentID: 'Please fill student ID',
        selectListApplicantAcademic: 'Select list of applicants from academic year',
        selectStudentFromAcademic: 'Select student database from academic year',
        fillInitiationDate: 'please fill date of admission',
        transferFail: 'Failed to transfer please try again'
    }
    
}

export const qualifiedApplicantsTH = {
    header:'รายชื่อผู้ผ่านการคัดเลือก',
    stepHeader:{
        one:'เลือกปีการศึกษา',
        two:'ตั้งค่าข้อมูลการเข้าศึกษา',
        three:'รายชื่อผู้ผ่านการคัดเลือก'
    },
    ListAcademicYear:'รายชื่อผู้สมัครจากปีการศึกษา',
    academicYearTransfer:'โอนไปฐานข้อมูลนักเรียนปีการศึกษา',
    createClassroom:'กรุณาสร้างห้องเรียนในระดับชั้นที่เลือกก่อนที่',
    date:'วันที่เข้าเรียน',
    transferred:'สำเร็จ',
    onProcess:'รอดำเนินการ',
    confirm:'ยืนยัน',
    transfer:'ดำเนินการโอนข้อมูล',
    cancel:'ยกเลิก',
    save:'บันทึก',
    datePlaceholder:'วว/ดด/ปป',
    step3Content:'กำหนดรหัสนักเรียน และห้องเรียนสำหรับนักเรียนใหม่ เพื่อนำเข้าฐานข้อมูลนักเรียน',
    suggestion:'คำแนะนำ',
    searchByApplicantsNameOnly: "ค้นหาโดย ชื่อนักเรียน", 
    guide:{
        content1:'รายชื่อผู้ผ่านการคัดเลือกจะแสดงเฉพาะรายชื่อผู้สมัครที่มีสถานะ“มอบตัวสำเร็จ”',
        content2:'วิธีการนำรายชื่อเข้าสู่ฐานข้อมูลนักเรียน',
        content3:'กำหนดปีการศึกษาที่ต้องการนำรายชื่อนักเรียนเข้า(สร้างปีการศึกษาใหม่ ไปที่',
        content4:'ตั้งค่าภาคการเรียน',
        content5:')',
        content6:'ระบุรหัสนักเรียนและห้องเรียนตามรายชื่อที่แสดง(สร้างห้องเรียนใหม่ไปที่',
        content7:'จัดการห้องเรียน',
        content8:')',
        content9:'ตรวจสอบความถูกต้องอีกครั้งแล้วกด“ดำเนินการโอนข้อมูล”',
        content10:'หลังจากโอนข้อมูลสำเร็จ จะไม่สามารถแก้ไขข้อมูลได้',
        content11:'ตรวจสอบฐานข้อมูลนักเรียนได้ที่',
        content12:'รายชื่อนักเรียน',
    },
    table:{
        fullname:'ชื่อ - นามสกุล',
        curriculum:'แผนการเรียน',
        grade:'ระดับชั้น',
        studentID:'รหัสนักเรียน',
        classroom:'ห้องเรียน',
        status:'สถานะ'
    },
    sheet:{
        academicYear:'ปีการศึกษา',
        listApplicants:'รายชื่อทั้งหมด',
        transferred:'โอนข้อมูลสำเร็จ',
        onProcess:'รอดำเนินการ',
    },
    input:{
        pleaseFill:'ระบุ',
        error:'ระบุช้อมูล',
        errorExist:'รหัสนักเรียนซ้ำ',
        select:'- เลือก -',
    },
    dialog:{
        headerUp:'สร้างรหัสนักเรียน',
        headerBottom:'เฉพาะรายชื่อที่ถูกเลือก',
        type:'ประเภท',
        id:'รหัส',
        numberDigit:'จำนวนหลัก',
        numberStart:'เริ่มจาก',
        example:'ตัวอย่างรหัสนักเรียน',
        add:'เพิ่ม',
        cancel:'ยกเลิก',
        createId:'สร้างรหัส'
    },
    acceptDialog:{
        transfer:'ดำเนินการโอนข้อมูล ?',
        head:'รายชื่อทั้งหมด : ',
        case:'รายการ',
        tail:'หลังจากยืนยันจะไม่สามารถแก้ไขข้อมูลได้'
    },
    createStudentID: 'สร้างรหัสนักเรียน',
    selectRound: 'เลือกรอบการสมัคร',
    selectAcademic: 'เลือกปีการศึกษา',
    error:{
        failToTransfer: 'โอนข้อมูลไม่สำเร็จ',
        case: 'รายการ',
        fillStartNumber: 'กรุณาระบุตัวเลขเริ่มต้น',
        maximumDigit: 'ตัวเลขเริ่มต้นไม่ควรเกินจำนวนหลัก',
        fillDigit: 'กรุณาระบุจำนวนหลัก',
        fillStudentID: 'กรุณาระบุรหัส',
        selectListApplicantAcademic: 'เลือกรายชื่อผู้สมัครจากปีการศึกษา',
        selectStudentFromAcademic: 'เลือกฐานข้อมูลนักเรียนปีการศึกษา',
        fillInitiationDate: 'ระบุวันที่เข้าศึกษา',
        transferFail: 'โอนข้อมูลไม่สำเร็จกรุณาลองใหม่อีกครั้ง'
    }
}